var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPause1 = function SvgIconPause1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 39"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B328C",
    d: "M11.611 4.68c0-2.584-2.6-4.68-5.806-4.68S0 2.096 0 4.68v29.641C0 36.905 2.599 39 5.805 39c3.206 0 5.806-2.095 5.806-4.679V4.68zM31 34.321C31 36.905 28.4 39 25.194 39s-5.806-2.095-5.806-4.679V4.68c0-2.584 2.6-4.68 5.806-4.68S31 2.096 31 4.68v29.641z"
  })));
};
export default SvgIconPause1;